module.exports = __webpack_public_path__ + "static/media/bigRail.72be5ea9.png";